import { createContext } from 'react';
import { IViewerAPI, ViewerEventsMap, EventEmitter } from 'viewer3d';

interface IViewerContext {
  viewer: IViewerAPI & EventEmitter<ViewerEventsMap> | null;
  initialize(canvasId: string): void;
}

const INITIAL_VALUE: IViewerContext = {
  viewer: null,
  initialize: () => null,
}

export const ViewerContext = createContext<IViewerContext>(INITIAL_VALUE);
